import axiosInstance from "@/api/axios-instance";

export async function approveUserRequest(id: string) {
  const response = await axiosInstance.patch(`/user-requests/${id}/approve`);
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to approve user request");
  }
  return response.data;
}
